module.exports = __webpack_public_path__ + "static/img/avatar2.929b19f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar2.jpg
// module id = jWzA
// module chunks = 22